var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"richest-container"},[_c('h3',[_vm._v("Net Worth")]),_c('p',[_vm._v("Compare your wealth to real people.")]),_c('RWPersonCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }